<template>
  <div
    v-bind:class="{
      'bg-glass': focused && editMemoSlug != memo.slug,
      disabled: focused && editMemoSlug != memo.slug,
      normal: !focused,
    }"
    ref="memo_container"
  >
    <div
      ref="memo"
      v-if="!is_edit && memo && memo.slug"
      @click="memoClicked(memo, $event)"
      @dblclick.stop.prevent="changeToEditMode"
      class="display"
      v-bind:class="{ all: show_all, no_fold: !needFold, showRecommend: showAiIcon && !is_Thread && !isInPinWindow }"
    >
      <div class="header">
        <a
          class="time"
          v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '点击日期' }"
          @click.stop.prevent="openThread(memo)"
          :href="'/mine/?memo_id=' + memo.slug"
          v-if="!is_recycl"
        >
          <span class="text" v-if="!isShowPin">{{ memo.created_at }}</span>
          <span class="text" v-if="isShowPin">{{ $t('components.Memo.pinned') }}・{{ memo.created_at }}</span>
          <span v-if="showAiIcon && memo.tipLoading" class="animate-wave text">
            <span class="w1"></span>
            <span class="w2"></span>
            <span class="w3"></span>
            <span class="w4"></span>
          </span>
          <span class="recommend" @click="showRecommend" v-if="showAiIcon && !is_Thread && !isInPinWindow">{{
            $t('tooltips.ai.recommend')
          }}</span>
        </a>
        <a class="time" href="javascript:;" v-else>{{ $t('components.Memo.delete_at') }} {{ memo.deleted_at }}</a>
        <div class="tools" v-if="!is_Sort">
          <span v-if="getDraft()" class="draft" style="color: #7d7d7d">
            <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24" fill="currentColor">
              <g fill="none">
                <path
                  d="M20.877 2.826l.153.144l.145.153a3.579 3.579 0 0 1-.145 4.908L9.062 19.999a2.25 2.25 0 0 1-1 .58l-5.115 1.395a.75.75 0 0 1-.92-.921l1.394-5.116a2.25 2.25 0 0 1 .58-.999L15.97 2.97a3.579 3.579 0 0 1 4.908-.144zM15 6.06l-9.938 9.938a.75.75 0 0 0-.193.333l-1.05 3.85l3.85-1.05A.75.75 0 0 0 8 18.938L17.94 9L15 6.06zM6.525 11l-1.5 1.5H2.75a.75.75 0 0 1 0-1.5h3.775zm4-4l-1.5 1.5H2.75a.75.75 0 1 1 0-1.5h7.775zm6.505-2.97l-.97.97l2.939 2.94l.97-.97a2.078 2.078 0 1 0-2.939-2.94zM14.525 3l-1.5 1.5H2.75a.75.75 0 1 1 0-1.5h11.775z"
                  fill="currentColor"
                />
              </g>
            </svg>
          </span>

          <span v-if="memo.is_show_cloud" class="not-sync" style="margin: 0 5px">
            <svg-icon
              :iconClass="isDark ? language + '-sync-dark' : language + '-sync-light'"
              :className="language + '-sync'"
            ></svg-icon>
          </span>

          <span class="similarity" v-if="isRecomment"> {{ parseInt(similarity * 100) }}%</span>
          <el-popover
            placement="bottom"
            width="180"
            popper-class="tools-popover"
            trigger="hover"
            v-model="tools_show"
            :visible-arrow="false"
          >
            <div class="popover-menu" v-if="!isInPinWindow">
              <div
                class="item"
                v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '编辑' }"
                @click.stop="changeToEditMode(memo)"
                v-if="!is_recycl"
              >
                {{ $t('components.Memo.edit') }}
              </div>
              <div
                class="item"
                v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '置顶' }"
                @click.stop="pinMemo(memo)"
                v-if="!is_recycl && !memo.pin"
              >
                {{ $t('components.Memo.pin') }}
              </div>
              <div
                class="item"
                v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '取消置顶' }"
                @click.stop="unpinMemo(memo)"
                v-if="!is_recycl && memo.pin"
              >
                {{ $t('components.Memo.unpin') }}
              </div>
              <div
                class="item"
                v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '新窗口打开' }"
                @click.stop="pinMemoToDesk(memo)"
                v-if="!is_recycl && isElectron"
              >
                {{ $t('components.Memo.openNewWindow') }}
              </div>
              <el-divider class="divider" v-if="!is_recycl"></el-divider>
              <div
                class="item"
                v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '分享' }"
                @click.stop="shareClicked(memo)"
                v-if="!is_recycl"
              >
                {{ $t('components.Memo.share') }}
              </div>
              <div
                class="item"
                v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '查看详情' }"
                @click.stop="openThread(memo)"
                v-if="!menu_thread_hidden && !is_recycl"
              >
                {{ $t('components.Memo.thread') }}
              </div>
              <div
                class="item"
                v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '复制链接' }"
                @click.stop="copyLink(memo)"
                v-if="!is_recycl"
              >
                {{ $t('components.Memo.copy_link') }}
              </div>
              <div
                class="item"
                v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '批注' }"
                @click.stop="addLinkedMemo(memo)"
                v-if="!is_recycl"
              >
                {{ $t('components.Memo.add_linked_memo') }}
              </div>
              <div
                class="item danger"
                v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '删除' }"
                @click.stop="removeMemo(memo)"
                v-if="!menu_delete_hidden && !is_recycl"
              >
                {{ $t('components.Memo.delete') }}
              </div>
              <el-divider class="divider" v-if="!is_recycl"></el-divider>
              <div class="item small" v-if="!menu_delete_hidden && !is_recycl">
                {{ $t('components.Memo.wordCount') }} : {{ memoWordCount }}
              </div>
              <div
                class="item"
                v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '恢复' }"
                @click.stop="restoreMemo(memo)"
                v-if="is_recycl"
              >
                {{ $t('components.Memo.restore') }}
              </div>
            </div>

            <div class="popover-menu" v-else>
              <div
                class="item"
                v-baidu-event-tracking="{ feature: 'MEMO新窗口', action: '编辑' }"
                @click.stop="changeToEditMode(memo)"
              >
                {{ $t('components.Memo.edit') }}
              </div>
              <div
                class="item"
                v-baidu-event-tracking="{ feature: 'MEMO新窗口', action: '应用内打开' }"
                @click.stop="openMemo(memo)"
              >
                {{ $t('components.Memo.open') }}
              </div>
              <el-divider class="divider" v-if="!is_recycl"></el-divider>
              <div class="item small" v-if="!menu_delete_hidden && !is_recycl">
                {{ $t('components.Memo.wordCount') }} : {{ memoWordCount }}
              </div>
            </div>

            <svg-icon slot="reference" iconClass="memoMoreAction" className="memoAction"></svg-icon>
          </el-popover>
        </div>
      </div>
      <div class="mainContent">
        <div
          class="content"
          :class="{
            'is-fold': needFold && !show_all && isShowExpand && !is_review,
          }"
          v-if="!is_Sort"
        >
          <div
            class="richText"
            ref="richText"
            v-html="renderMemoContent(memo.content)"
            :style="{
              maxHeight: needFold && !show_all && isShowExpand && !is_review ? '160px' : 'none',
            }"
          ></div>
        </div>
        <div class="tool" v-if="needFold && isShowExpand && !is_review">
          <span
            class="showBtn"
            @click.stop.prevent="showAll"
            v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '展开' }"
            v-if="!show_all"
          >
            {{ $t('components.Memo.show_all') }}
          </span>
          <span
            class="hideBtn"
            @click.stop.prevent="showSummary"
            v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '收起' }"
            v-if="show_all"
          >
            {{ $t('components.Memo.show_summary') }}
          </span>
        </div>

        <div class="files" v-if="memo.files && memo.files.length && !is_Sort" v-viewer="v_viewer_option">
          <el-image
            v-bind:key="file.url"
            :src="isOnLine ? getImgPreviewUrl(file) : isLocal ? getImgPreviewUrl(file) : `/img/img-${language}-err.png`"
            :data-source="
              isOnLine ? (file.url ? file.url : `/img/img-${language}-err.png`) : `/img/img-${language}-err.png`
            "
            v-for="(file, index) in imageFileList"
            :ref="memo.slug + '-image' + index"
            fit="cover"
            v-baidu-event-tracking="{ feature: 'MEMO卡片', action: '点击图片' }"
          >
            <div slot="placeholder" class="image-slot">
              <svg width="100" height="100" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                  x="0.5"
                  y="0.5"
                  width="83"
                  height="83"
                  rx="3.5"
                  fill="#EFEFEF"
                  stroke="#9D9D9D"
                  stroke-dasharray="2 2"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M49.375 35.2857H33.625C33.2769 35.2857 32.9431 35.4212 32.6969 35.6623C32.4508 35.9034 32.3125 36.2304 32.3125 36.5714V49.4286C32.3125 49.7696 32.4508 50.0966 32.6969 50.3377C32.9431 50.5788 33.2769 50.7143 33.625 50.7143H49.375C49.7231 50.7143 50.0569 50.5788 50.3031 50.3377C50.5492 50.0966 50.6875 49.7696 50.6875 49.4286V36.5714C50.6875 36.2304 50.5492 35.9034 50.3031 35.6623C50.0569 35.4212 49.7231 35.2857 49.375 35.2857ZM33.625 34C32.9288 34 32.2611 34.2709 31.7688 34.7532C31.2766 35.2354 31 35.8894 31 36.5714V49.4286C31 50.1106 31.2766 50.7646 31.7688 51.2468C32.2611 51.7291 32.9288 52 33.625 52H49.375C49.7197 52 50.0611 51.9335 50.3795 51.8043C50.698 51.675 50.9874 51.4856 51.2312 51.2468C51.4749 51.0081 51.6683 50.7246 51.8002 50.4126C51.9321 50.1006 52 49.7663 52 49.4286V36.5714C52 35.8894 51.7234 35.2354 51.2312 34.7532C50.7389 34.2709 50.0712 34 49.375 34H33.625Z"
                  fill="#9D9D9D"
                />
                <path
                  d="M45.091 43.1796C45.1918 43.0885 45.3216 43.0284 45.4622 43.0078C45.6027 42.9873 45.7468 43.0074 45.8741 43.0652L51 45.4615V51H32V48.5384L35.591 45.6412C35.7019 45.541 35.8477 45.4786 36.0035 45.4647C36.1593 45.4508 36.3157 45.4862 36.446 45.5649L40.056 47.7471L45.091 43.1809V43.1796Z"
                  fill="#9D9D9D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M37 42C37.2626 42 37.5227 41.9483 37.7654 41.8478C38.008 41.7472 38.2285 41.5999 38.4142 41.4142C38.5999 41.2285 38.7472 41.008 38.8478 40.7654C38.9483 40.5227 39 40.2626 39 40C39 39.7374 38.9483 39.4773 38.8478 39.2346C38.7472 38.992 38.5999 38.7715 38.4142 38.5858C38.2285 38.4001 38.008 38.2528 37.7654 38.1522C37.5227 38.0517 37.2626 38 37 38C36.4696 38 35.9609 38.2107 35.5858 38.5858C35.2107 38.9609 35 39.4696 35 40C35 40.5304 35.2107 41.0391 35.5858 41.4142C35.9609 41.7893 36.4696 42 37 42Z"
                  fill="#9D9D9D"
                />
              </svg>
            </div>

            <div slot="error" class="image-slot" v-if="!isOnLine">
              <svg
                width="100"
                height="100"
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                v-if="me.language != 'en'"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="99"
                  height="99"
                  rx="7.5"
                  fill="#EFEFEF"
                  stroke="#9D9D9D"
                  stroke-dasharray="2 2"
                />
                <path
                  d="M27.0043 59.5495H26.3343L26.7443 58.9095C26.4243 58.7195 26.0943 58.5395 25.7443 58.3695C26.0243 58.1695 26.3043 57.9495 26.5943 57.6895L25.8743 57.2495C25.5643 57.5095 25.2343 57.7495 24.8943 57.9695C24.3643 57.7295 23.8043 57.5095 23.2243 57.3095L22.7943 57.9495C23.1943 58.0895 23.5943 58.2495 24.0043 58.4295C23.5743 58.6095 23.1243 58.7595 22.6543 58.8795L23.0543 59.5495H22.4343V57.5495H21.4443V60.4095H23.8043L23.6543 60.8895H20.8243V64.8595H21.8243V61.8295H23.3043C23.1343 62.2195 22.9543 62.5595 22.7743 62.8495C22.7143 62.9295 22.5843 62.9795 22.3943 62.9995L22.6243 63.9295C24.2343 63.7495 25.4343 63.5995 26.2243 63.4595C26.2843 63.5895 26.3543 63.7295 26.4143 63.8695L27.2443 63.4595C26.9543 62.8795 26.6543 62.3395 26.3543 61.8295H27.6243V63.6395C27.6243 63.8295 27.5043 63.9295 27.2843 63.9295L26.5843 63.8895L26.8343 64.8595H27.6043C28.2843 64.8595 28.6243 64.5195 28.6243 63.8595V60.8895H24.6543C24.7043 60.7295 24.7543 60.5695 24.8143 60.4095H27.9943V57.5495H27.0043V59.5495ZM25.3343 61.8295C25.4943 62.0895 25.6543 62.3595 25.8143 62.6495C25.1543 62.7495 24.4743 62.8395 23.7743 62.9195C23.9543 62.5995 24.1243 62.2395 24.2943 61.8295H25.3343ZM24.9243 58.8595C25.3343 59.0595 25.7443 59.2895 26.1643 59.5495H23.2943C23.9643 59.3095 24.5043 59.0795 24.9243 58.8595ZM25.0243 55.5195L23.9543 55.6995C24.0543 55.8795 24.1543 56.0695 24.2543 56.2695H20.3843V57.2295H29.0443V56.2695H25.3243C25.2243 55.9995 25.1243 55.7495 25.0243 55.5195ZM33.6843 62.6595C32.6943 63.0195 31.5343 63.2995 30.2143 63.5195L30.3443 64.5395C31.5943 64.3095 32.7043 64.0095 33.6843 63.6395V62.6595ZM31.6943 55.5295C31.3643 56.5995 30.9743 57.5795 30.5243 58.4795C30.3943 58.6595 30.2543 58.7895 30.0943 58.8595L30.3443 59.8095L31.7643 59.6195C31.3343 60.3795 30.9743 60.9195 30.6943 61.2195C30.5643 61.3395 30.4043 61.4395 30.2243 61.5195L30.4943 62.4595C31.4643 62.3395 32.4943 62.0895 33.5843 61.7195V60.7895C32.9543 61.0095 32.3343 61.1795 31.7243 61.3095C32.2643 60.5895 32.9343 59.4795 33.7143 57.9695L32.7843 57.6095C32.6043 57.9895 32.4243 58.3395 32.2643 58.6795L31.3043 58.7995C31.7743 58.0595 32.2343 57.0995 32.6943 55.9295L31.6943 55.5295ZM38.5543 57.2595L36.2143 57.5895V55.5895H35.1643V57.7295L33.7443 57.9295L33.8943 58.8895L35.1843 58.7095C35.2043 59.0695 35.2243 59.4295 35.2643 59.7695L33.5743 60.0395L33.7243 61.0195L35.4043 60.7595C35.4343 60.9595 35.4743 61.1595 35.5243 61.3595C35.6343 61.8395 35.7743 62.2895 35.9543 62.6995C35.2543 63.2095 34.4643 63.5995 33.5843 63.8795L34.1943 64.7195C34.9843 64.4795 35.7343 64.1095 36.4343 63.6095C36.4743 63.6795 36.5343 63.7495 36.5943 63.8295C37.0443 64.4295 37.5243 64.7395 38.0443 64.7495C38.6243 64.7495 39.0543 64.1095 39.3543 62.8295L38.4643 62.2495C38.3243 63.1495 38.1443 63.5995 37.9243 63.5995C37.7043 63.5995 37.4643 63.3895 37.1943 62.9895C37.7443 62.4795 38.2643 61.8695 38.7543 61.1595L37.9243 60.5995C37.5743 61.1195 37.1843 61.5995 36.7543 62.0195C36.6343 61.6595 36.5343 61.2595 36.4543 60.8095C36.4343 60.7395 36.4243 60.6695 36.4243 60.5995L38.9843 60.1995L38.8243 59.2195L36.3043 59.6095C36.2643 59.2795 36.2443 58.9295 36.2343 58.5595L38.7043 58.2195L38.5543 57.2595ZM37.3343 55.5495L36.5443 56.0495C36.9943 56.4995 37.3543 56.9095 37.6143 57.2795L38.4343 56.7095C38.1743 56.3895 37.8043 55.9995 37.3343 55.5495ZM40.9743 56.0095V57.0295H43.7343V57.6095C43.7143 58.1395 43.6743 58.6395 43.6143 59.1195H40.3343V60.1295H43.4343C43.3043 60.6495 43.1443 61.1295 42.9443 61.5695C42.4643 62.5095 41.5443 63.2995 40.1643 63.9295L40.7543 64.8595C42.1343 64.2795 43.1343 63.4395 43.7543 62.3395C44.0843 61.7195 44.3343 60.9795 44.5143 60.1295H45.0543V63.4395C45.0543 64.2695 45.4443 64.6895 46.2243 64.6895H47.8143C48.2343 64.6895 48.5543 64.5895 48.7543 64.3995C48.9743 64.1995 49.1343 63.5595 49.2243 62.4795L48.2443 62.1495C48.2043 62.9095 48.1343 63.3595 48.0243 63.4995C47.9343 63.6395 47.7943 63.7195 47.6143 63.7195H46.5443C46.2443 63.7195 46.0943 63.5495 46.0943 63.2295V60.1295H49.0843V59.1195H44.6843C44.7443 58.6495 44.7743 58.1495 44.7943 57.6095V57.0295H48.2943V56.0095H40.9743ZM55.3743 55.6195V57.0995H53.1143V58.1095H55.3743V59.6595H52.6343V60.6795H54.7943C54.1143 62.2795 53.5543 63.2595 53.1343 63.6395C53.0843 63.6695 53.0143 63.6995 52.9143 63.7295L53.1443 64.6395C54.8843 64.4695 56.4943 64.2395 57.9843 63.9395C58.1043 64.2395 58.2343 64.5595 58.3643 64.8995L59.3543 64.4595C58.9143 63.3195 58.4043 62.2595 57.8243 61.2595L56.8143 61.5995C57.0743 62.0395 57.3243 62.5095 57.5743 63.0295C56.5443 63.2395 55.5043 63.4095 54.4643 63.5295C54.8843 62.9095 55.3743 61.9595 55.9143 60.6795H59.1543V59.6595H56.4343V58.1095H58.8943V57.0995H56.4343V55.6195H55.3743ZM51.1143 55.6795L50.3643 56.3995C51.0743 56.9395 51.6243 57.4395 52.0043 57.9095L52.7443 57.1595C52.2943 56.6695 51.7543 56.1795 51.1143 55.6795ZM50.8643 58.0195L50.1243 58.7395C50.7743 59.2895 51.2743 59.7995 51.6243 60.2595L52.3743 59.5195C51.9543 59.0195 51.4543 58.5195 50.8643 58.0195ZM51.7643 60.8495C51.3343 62.0295 50.8243 63.1895 50.2343 64.3095L51.2843 64.7695C51.8043 63.6695 52.2843 62.4895 52.7143 61.2395L51.7643 60.8495ZM61.6443 59.2895V63.1195H67.8243V59.2895H61.6443ZM66.8043 62.1995H62.6643V61.6595H66.8043V62.1995ZM62.6643 60.7795V60.2095H66.8043V60.7795H62.6643ZM60.5843 56.3895V57.3495H63.3343C62.5843 57.8895 61.5043 58.3395 60.0843 58.7195L60.6543 59.6395C62.2443 59.0495 63.4343 58.3095 64.2243 57.4195V58.9995H65.2443V57.4195C65.9943 58.3295 67.2043 59.0695 68.8743 59.6395L69.3243 58.6995C67.9443 58.3595 66.8943 57.9095 66.1543 57.3495H68.8843V56.3895H65.2443V55.5795H64.2243V56.3895H60.5843ZM60.3843 63.6395V64.5895H69.0543V63.6395H60.3843ZM70.8743 57.3295V58.2095H73.5243C73.4243 58.3495 73.3243 58.4995 73.2243 58.6395H70.3343V59.5595H72.4743C71.8143 60.2595 71.0143 60.9195 70.0743 61.5595L70.6343 62.4595C71.1143 62.1195 71.5743 61.7695 72.0143 61.3995V64.8695H73.0043V64.4995H77.2543V64.8695H78.2443V59.9795H73.4243C73.5343 59.8495 73.6443 59.7095 73.7643 59.5595H79.1743V58.6395H74.3843C74.4643 58.4995 74.5443 58.3495 74.6243 58.2095H78.5943V57.3295H75.0343C75.0943 57.1695 75.1543 57.0095 75.2143 56.8395C76.4843 56.7395 77.5943 56.5895 78.5543 56.3895L78.0743 55.5695C76.1243 55.9395 73.7443 56.1295 70.9343 56.1295L71.2143 56.9795C72.2743 56.9795 73.2743 56.9495 74.2043 56.9095L74.0143 57.3295H70.8743ZM73.0043 62.0195H77.2543V62.4295H73.0043V62.0195ZM77.2543 61.2395H73.0043V60.8195H77.2543V61.2395ZM73.0043 63.2095H77.2543V63.6595H73.0043V63.2095Z"
                  fill="#9D9D9D"
                />
                <g clip-path="url(#clip0_14306_4434)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M40.9859 32.1288C40.8477 32.4824 40.746 32.8492 40.6823 33.2235C37.6894 33.8842 35.4287 36.4913 35.4287 39.6395C35.4287 43.2967 38.4787 46.2145 42.1805 46.2145H55.0716L53.2859 44.4288H42.1805C39.4126 44.4288 37.2144 42.2592 37.2144 39.6395C37.2144 37.202 39.1144 35.152 41.6073 34.8788L42.4037 34.7895V33.9913C42.4037 33.8574 42.4144 33.7199 42.4359 33.5788L40.9859 32.1288ZM45.5394 29.5395L44.2448 28.2449C45.8622 27.158 47.7658 26.5757 49.7144 26.5717C54.518 26.5717 58.5055 30.1431 58.9394 34.7485C61.7823 35.1502 64.0001 37.5306 64.0001 40.452C63.9971 41.4224 63.747 42.3761 63.2733 43.223C62.7997 44.07 62.1182 44.7824 61.293 45.2931L59.9841 43.9842C61.318 43.3181 62.2144 41.9752 62.2144 40.452C62.2144 38.2806 60.393 36.4735 58.0841 36.4735H57.1912V35.5806C57.193 31.6163 53.8716 28.3574 49.7144 28.3574C48.1519 28.3574 46.718 28.8217 45.5376 29.5377L45.5394 29.5395ZM59.7966 48.6324L38.368 27.2038L39.6323 25.9395L61.0609 47.3681L59.7984 48.6306L59.7966 48.6324Z"
                    fill="#979797"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_14306_4434">
                    <rect x="35.4287" y="23" width="28.5714" height="28.5714" rx="8" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
                <rect
                  x="0.5"
                  y="0.5"
                  width="99"
                  height="99"
                  rx="7.5"
                  fill="#EFEFEF"
                  stroke="#9D9D9D"
                  stroke-dasharray="2 2"
                />
                <path
                  d="M38.3831 65.08C36.7364 65.08 35.9131 64.1633 35.9131 62.33V60.75C35.9131 58.9167 36.7498 58 38.4231 58C39.1898 58 39.7964 58.2167 40.2431 58.65C40.6898 59.0767 40.9131 59.7767 40.9131 60.75V62.33C40.9131 63.3033 40.6831 64.0067 40.2231 64.44C39.7698 64.8667 39.1564 65.08 38.3831 65.08ZM38.4231 63.91C38.8231 63.91 39.1198 63.7833 39.3131 63.53C39.5064 63.27 39.6031 62.8633 39.6031 62.31V60.82C39.6031 60.2333 39.5064 59.81 39.3131 59.55C39.1198 59.2833 38.8231 59.15 38.4231 59.15C38.0031 59.15 37.6998 59.28 37.5131 59.54C37.3264 59.7933 37.2331 60.22 37.2331 60.82V62.31C37.2331 62.8767 37.3264 63.2867 37.5131 63.54C37.6998 63.7867 38.0031 63.91 38.4231 63.91ZM43.9227 58.94C43.7427 58.94 43.6094 58.9833 43.5227 59.07C43.4427 59.15 43.4027 59.2733 43.4027 59.44V59.8H44.3327V60.67H43.4027V65H42.1727V60.67H41.6227V59.8H42.1727V59.49C42.1727 59.05 42.296 58.71 42.5427 58.47C42.796 58.2233 43.1527 58.1 43.6127 58.1H44.3327V58.94H43.9227ZM47.2625 58.94C47.0825 58.94 46.9492 58.9833 46.8625 59.07C46.7825 59.15 46.7425 59.2733 46.7425 59.44V59.8H47.6725V60.67H46.7425V65H45.5125V60.67H44.9625V59.8H45.5125V59.49C45.5125 59.05 45.6359 58.71 45.8825 58.47C46.1359 58.2233 46.4925 58.1 46.9525 58.1H47.6725V58.94H47.2625ZM50.0625 65C49.5625 65 49.1725 64.8633 48.8925 64.59C48.6192 64.3167 48.4825 63.9267 48.4825 63.42V58.1H49.7225V63.34C49.7225 63.5533 49.7592 63.7067 49.8325 63.8C49.9125 63.8867 50.0392 63.93 50.2125 63.93H50.6325V65H50.0625ZM51.4035 59.8H52.6335V65H51.4035V59.8ZM51.3835 58.1H52.6435V59.09H51.3835V58.1ZM53.7656 59.8H54.9756V60.27C55.1289 60.0967 55.3123 59.9667 55.5256 59.88C55.7456 59.7867 55.9723 59.74 56.2056 59.74C56.7389 59.74 57.1523 59.9067 57.4456 60.24C57.7389 60.5733 57.8856 61.03 57.8856 61.61V65H56.6456V61.76C56.6456 61.4667 56.5723 61.24 56.4256 61.08C56.2789 60.92 56.0823 60.84 55.8356 60.84C55.5956 60.84 55.3956 60.92 55.2356 61.08C55.0823 61.24 55.0056 61.4667 55.0056 61.76V65H53.7656V59.8ZM60.1009 62.77V62.91C60.1009 63.2967 60.1876 63.5733 60.3609 63.74C60.5342 63.9067 60.7809 63.99 61.1009 63.99C61.3476 63.99 61.5409 63.94 61.6809 63.84C61.8209 63.7333 61.8976 63.5867 61.9109 63.4L61.9209 63.37H63.1009V63.42C63.1009 63.9133 62.9176 64.31 62.5509 64.61C62.1842 64.91 61.6842 65.06 61.0509 65.06C60.3842 65.06 59.8542 64.87 59.4609 64.49C59.0676 64.1033 58.8709 63.51 58.8709 62.71V62.08C58.8709 61.3 59.0609 60.7167 59.4409 60.33C59.8209 59.9367 60.3442 59.74 61.0109 59.74C61.6642 59.74 62.1809 59.9367 62.5609 60.33C62.9476 60.7233 63.1409 61.3067 63.1409 62.08V62.77H60.1009ZM61.0109 60.8C60.7176 60.8 60.4909 60.8833 60.3309 61.05C60.1776 61.2167 60.1009 61.4967 60.1009 61.89V61.92H61.9009V61.79C61.9009 61.13 61.6042 60.8 61.0109 60.8ZM30.9077 76.06C30.2543 76.06 29.7377 75.8833 29.3577 75.53C28.9843 75.1767 28.7977 74.6267 28.7977 73.88V72.91C28.7977 72.17 28.9843 71.6233 29.3577 71.27C29.7377 70.9167 30.2543 70.74 30.9077 70.74C31.5477 70.74 32.0477 70.9033 32.4077 71.23C32.7677 71.5567 32.9477 72.01 32.9477 72.59V72.69H31.7677V72.63C31.7677 72.3833 31.691 72.19 31.5377 72.05C31.391 71.91 31.1877 71.84 30.9277 71.84C30.3277 71.84 30.0277 72.2033 30.0277 72.93V73.87C30.0277 74.2633 30.1043 74.5433 30.2577 74.71C30.4177 74.8767 30.641 74.96 30.9277 74.96C31.1877 74.96 31.391 74.8933 31.5377 74.76C31.691 74.6267 31.7677 74.44 31.7677 74.2V74.14H32.9477V74.21C32.9477 74.7833 32.7677 75.2367 32.4077 75.57C32.0477 75.8967 31.5477 76.06 30.9077 76.06ZM35.8165 70.74C36.4765 70.74 36.9832 70.8967 37.3365 71.21C37.6898 71.5167 37.8665 71.9733 37.8665 72.58V76H36.6665V75.55C36.4932 75.73 36.3132 75.86 36.1265 75.94C35.9465 76.02 35.7165 76.06 35.4365 76.06C34.9032 76.06 34.4898 75.9167 34.1965 75.63C33.9032 75.3433 33.7565 74.9467 33.7565 74.44C33.7565 73.9733 33.9132 73.6067 34.2265 73.34C34.5398 73.0667 34.9765 72.93 35.5365 72.93H36.6365V72.52C36.6365 71.9667 36.3598 71.69 35.8065 71.69C35.5732 71.69 35.3865 71.75 35.2465 71.87C35.1132 71.9833 35.0465 72.1367 35.0465 72.33V72.36H33.8965V72.32C33.8965 71.8333 34.0698 71.45 34.4165 71.17C34.7632 70.8833 35.2298 70.74 35.8165 70.74ZM35.7165 75.06C36.0432 75.06 36.2765 74.9867 36.4165 74.84C36.5632 74.6867 36.6365 74.4567 36.6365 74.15V73.78H35.7365C35.2165 73.78 34.9565 73.99 34.9565 74.41C34.9565 74.8433 35.2098 75.06 35.7165 75.06ZM38.9463 70.8H40.1563V71.27C40.3096 71.0967 40.4929 70.9667 40.7063 70.88C40.9263 70.7867 41.1529 70.74 41.3863 70.74C41.9196 70.74 42.3329 70.9067 42.6263 71.24C42.9196 71.5733 43.0663 72.03 43.0663 72.61V76H41.8263V72.76C41.8263 72.4667 41.7529 72.24 41.6063 72.08C41.4596 71.92 41.2629 71.84 41.0163 71.84C40.7763 71.84 40.5763 71.92 40.4163 72.08C40.2629 72.24 40.1863 72.4667 40.1863 72.76V76H38.9463V70.8ZM43.8839 69.1H45.0539V71.1L43.8839 72.09V69.1ZM47.6375 71.67V74.42C47.6375 74.7733 47.8075 74.95 48.1475 74.95H48.5375V76H47.9475C47.4742 76 47.0975 75.8667 46.8175 75.6C46.5442 75.3267 46.4075 74.96 46.4075 74.5V71.67H45.6875V70.8H46.4075V69.78L47.6375 69.35V70.8H48.6375V71.67H47.6375ZM51.133 70.8H52.443L53.453 74.1L54.453 70.8H55.763L53.953 76H52.933L51.133 70.8ZM56.4474 70.8H57.6774V76H56.4474V70.8ZM56.4274 69.1H57.6874V70.09H56.4274V69.1ZM59.9495 73.77V73.91C59.9495 74.2967 60.0362 74.5733 60.2095 74.74C60.3829 74.9067 60.6295 74.99 60.9495 74.99C61.1962 74.99 61.3895 74.94 61.5295 74.84C61.6695 74.7333 61.7462 74.5867 61.7595 74.4L61.7695 74.37H62.9495V74.42C62.9495 74.9133 62.7662 75.31 62.3995 75.61C62.0329 75.91 61.5329 76.06 60.8995 76.06C60.2329 76.06 59.7029 75.87 59.3095 75.49C58.9162 75.1033 58.7195 74.51 58.7195 73.71V73.08C58.7195 72.3 58.9095 71.7167 59.2895 71.33C59.6695 70.9367 60.1929 70.74 60.8595 70.74C61.5129 70.74 62.0295 70.9367 62.4095 71.33C62.7962 71.7233 62.9895 72.3067 62.9895 73.08V73.77H59.9495ZM60.8595 71.8C60.5662 71.8 60.3395 71.8833 60.1795 72.05C60.0262 72.2167 59.9495 72.4967 59.9495 72.89V72.92H61.7495V72.79C61.7495 72.13 61.4529 71.8 60.8595 71.8ZM63.3791 70.8H64.6891L65.4991 74.1L66.4991 70.8H67.4291L68.4291 74.1L69.2391 70.8H70.5591L69.0291 76H67.9791L66.9591 72.63L65.9491 76H64.8991L63.3791 70.8Z"
                  fill="#9D9D9D"
                />
                <g clip-path="url(#clip0_14669_3492)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M41.5571 32.1288C41.419 32.4824 41.3173 32.8492 41.2536 33.2235C38.2607 33.8842 36 36.4913 36 39.6395C36 43.2967 39.05 46.2145 42.7518 46.2145H55.6429L53.8571 44.4288H42.7518C39.9839 44.4288 37.7857 42.2592 37.7857 39.6395C37.7857 37.202 39.6857 35.152 42.1786 34.8788L42.975 34.7895V33.9913C42.975 33.8574 42.9857 33.7199 43.0071 33.5788L41.5571 32.1288ZM46.1107 29.5395L44.8161 28.2449C46.4335 27.158 48.3371 26.5757 50.2857 26.5717C55.0893 26.5717 59.0768 30.1431 59.5107 34.7485C62.3536 35.1502 64.5714 37.5306 64.5714 40.452C64.5684 41.4224 64.3182 42.3761 63.8446 43.223C63.371 44.07 62.6895 44.7824 61.8643 45.2931L60.5554 43.9842C61.8893 43.3181 62.7857 41.9752 62.7857 40.452C62.7857 38.2806 60.9643 36.4735 58.6554 36.4735H57.7625V35.5806C57.7643 31.6163 54.4429 28.3574 50.2857 28.3574C48.7232 28.3574 47.2893 28.8217 46.1089 29.5377L46.1107 29.5395ZM60.3679 48.6324L38.9393 27.2038L40.2036 25.9395L61.6321 47.3681L60.3696 48.6306L60.3679 48.6324Z"
                    fill="#979797"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_14669_3492">
                    <rect x="36" y="23" width="28.5714" height="28.5714" rx="8" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </el-image>

          <AudioPlayerVue v-for="file in audioFileList" :key="file.id" :src="file.url" />
        </div>

        <div v-if="is_Sort" class="sortContent content">
          <div class="textContent">
            <div class="richText" ref="richText" v-if="memo.content" v-html="renderMemoContent(memo.content)"></div>
            <div class="files" v-if="memo.files && memo.files.length && is_Sort">
              <template>
                <el-image
                  v-bind:key="file.id"
                  :src="getImgPreviewUrl(file)"
                  :data-source="
                    isOnLine ? (file.url ? file.url : `./img/img-${language}-err.png`) : `./img/img-${language}-err.png`
                  "
                  v-for="(file, index) in imageFileList"
                  :ref="memo.slug + '-image' + index"
                  fit="cover"
                >
                  <div slot="placeholder" class="image-slot">
                    <svg width="100" height="100" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect
                        x="0.5"
                        y="0.5"
                        width="83"
                        height="83"
                        rx="3.5"
                        fill="#EFEFEF"
                        stroke="#9D9D9D"
                        stroke-dasharray="2 2"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M49.375 35.2857H33.625C33.2769 35.2857 32.9431 35.4212 32.6969 35.6623C32.4508 35.9034 32.3125 36.2304 32.3125 36.5714V49.4286C32.3125 49.7696 32.4508 50.0966 32.6969 50.3377C32.9431 50.5788 33.2769 50.7143 33.625 50.7143H49.375C49.7231 50.7143 50.0569 50.5788 50.3031 50.3377C50.5492 50.0966 50.6875 49.7696 50.6875 49.4286V36.5714C50.6875 36.2304 50.5492 35.9034 50.3031 35.6623C50.0569 35.4212 49.7231 35.2857 49.375 35.2857ZM33.625 34C32.9288 34 32.2611 34.2709 31.7688 34.7532C31.2766 35.2354 31 35.8894 31 36.5714V49.4286C31 50.1106 31.2766 50.7646 31.7688 51.2468C32.2611 51.7291 32.9288 52 33.625 52H49.375C49.7197 52 50.0611 51.9335 50.3795 51.8043C50.698 51.675 50.9874 51.4856 51.2312 51.2468C51.4749 51.0081 51.6683 50.7246 51.8002 50.4126C51.9321 50.1006 52 49.7663 52 49.4286V36.5714C52 35.8894 51.7234 35.2354 51.2312 34.7532C50.7389 34.2709 50.0712 34 49.375 34H33.625Z"
                        fill="#9D9D9D"
                      />
                      <path
                        d="M45.091 43.1796C45.1918 43.0885 45.3216 43.0284 45.4622 43.0078C45.6027 42.9873 45.7468 43.0074 45.8741 43.0652L51 45.4615V51H32V48.5384L35.591 45.6412C35.7019 45.541 35.8477 45.4786 36.0035 45.4647C36.1593 45.4508 36.3157 45.4862 36.446 45.5649L40.056 47.7471L45.091 43.1809V43.1796Z"
                        fill="#9D9D9D"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M37 42C37.2626 42 37.5227 41.9483 37.7654 41.8478C38.008 41.7472 38.2285 41.5999 38.4142 41.4142C38.5999 41.2285 38.7472 41.008 38.8478 40.7654C38.9483 40.5227 39 40.2626 39 40C39 39.7374 38.9483 39.4773 38.8478 39.2346C38.7472 38.992 38.5999 38.7715 38.4142 38.5858C38.2285 38.4001 38.008 38.2528 37.7654 38.1522C37.5227 38.0517 37.2626 38 37 38C36.4696 38 35.9609 38.2107 35.5858 38.5858C35.2107 38.9609 35 39.4696 35 40C35 40.5304 35.2107 41.0391 35.5858 41.4142C35.9609 41.7893 36.4696 42 37 42Z"
                        fill="#9D9D9D"
                      />
                    </svg>
                  </div>

                  <div slot="error" class="image-slot" v-if="!isOnLine">
                    <svg
                      width="100"
                      height="100"
                      viewBox="0 0 100 100"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      v-if="me.language != 'en'"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="99"
                        height="99"
                        rx="7.5"
                        fill="#EFEFEF"
                        stroke="#9D9D9D"
                        stroke-dasharray="2 2"
                      />
                      <path
                        d="M27.0043 59.5495H26.3343L26.7443 58.9095C26.4243 58.7195 26.0943 58.5395 25.7443 58.3695C26.0243 58.1695 26.3043 57.9495 26.5943 57.6895L25.8743 57.2495C25.5643 57.5095 25.2343 57.7495 24.8943 57.9695C24.3643 57.7295 23.8043 57.5095 23.2243 57.3095L22.7943 57.9495C23.1943 58.0895 23.5943 58.2495 24.0043 58.4295C23.5743 58.6095 23.1243 58.7595 22.6543 58.8795L23.0543 59.5495H22.4343V57.5495H21.4443V60.4095H23.8043L23.6543 60.8895H20.8243V64.8595H21.8243V61.8295H23.3043C23.1343 62.2195 22.9543 62.5595 22.7743 62.8495C22.7143 62.9295 22.5843 62.9795 22.3943 62.9995L22.6243 63.9295C24.2343 63.7495 25.4343 63.5995 26.2243 63.4595C26.2843 63.5895 26.3543 63.7295 26.4143 63.8695L27.2443 63.4595C26.9543 62.8795 26.6543 62.3395 26.3543 61.8295H27.6243V63.6395C27.6243 63.8295 27.5043 63.9295 27.2843 63.9295L26.5843 63.8895L26.8343 64.8595H27.6043C28.2843 64.8595 28.6243 64.5195 28.6243 63.8595V60.8895H24.6543C24.7043 60.7295 24.7543 60.5695 24.8143 60.4095H27.9943V57.5495H27.0043V59.5495ZM25.3343 61.8295C25.4943 62.0895 25.6543 62.3595 25.8143 62.6495C25.1543 62.7495 24.4743 62.8395 23.7743 62.9195C23.9543 62.5995 24.1243 62.2395 24.2943 61.8295H25.3343ZM24.9243 58.8595C25.3343 59.0595 25.7443 59.2895 26.1643 59.5495H23.2943C23.9643 59.3095 24.5043 59.0795 24.9243 58.8595ZM25.0243 55.5195L23.9543 55.6995C24.0543 55.8795 24.1543 56.0695 24.2543 56.2695H20.3843V57.2295H29.0443V56.2695H25.3243C25.2243 55.9995 25.1243 55.7495 25.0243 55.5195ZM33.6843 62.6595C32.6943 63.0195 31.5343 63.2995 30.2143 63.5195L30.3443 64.5395C31.5943 64.3095 32.7043 64.0095 33.6843 63.6395V62.6595ZM31.6943 55.5295C31.3643 56.5995 30.9743 57.5795 30.5243 58.4795C30.3943 58.6595 30.2543 58.7895 30.0943 58.8595L30.3443 59.8095L31.7643 59.6195C31.3343 60.3795 30.9743 60.9195 30.6943 61.2195C30.5643 61.3395 30.4043 61.4395 30.2243 61.5195L30.4943 62.4595C31.4643 62.3395 32.4943 62.0895 33.5843 61.7195V60.7895C32.9543 61.0095 32.3343 61.1795 31.7243 61.3095C32.2643 60.5895 32.9343 59.4795 33.7143 57.9695L32.7843 57.6095C32.6043 57.9895 32.4243 58.3395 32.2643 58.6795L31.3043 58.7995C31.7743 58.0595 32.2343 57.0995 32.6943 55.9295L31.6943 55.5295ZM38.5543 57.2595L36.2143 57.5895V55.5895H35.1643V57.7295L33.7443 57.9295L33.8943 58.8895L35.1843 58.7095C35.2043 59.0695 35.2243 59.4295 35.2643 59.7695L33.5743 60.0395L33.7243 61.0195L35.4043 60.7595C35.4343 60.9595 35.4743 61.1595 35.5243 61.3595C35.6343 61.8395 35.7743 62.2895 35.9543 62.6995C35.2543 63.2095 34.4643 63.5995 33.5843 63.8795L34.1943 64.7195C34.9843 64.4795 35.7343 64.1095 36.4343 63.6095C36.4743 63.6795 36.5343 63.7495 36.5943 63.8295C37.0443 64.4295 37.5243 64.7395 38.0443 64.7495C38.6243 64.7495 39.0543 64.1095 39.3543 62.8295L38.4643 62.2495C38.3243 63.1495 38.1443 63.5995 37.9243 63.5995C37.7043 63.5995 37.4643 63.3895 37.1943 62.9895C37.7443 62.4795 38.2643 61.8695 38.7543 61.1595L37.9243 60.5995C37.5743 61.1195 37.1843 61.5995 36.7543 62.0195C36.6343 61.6595 36.5343 61.2595 36.4543 60.8095C36.4343 60.7395 36.4243 60.6695 36.4243 60.5995L38.9843 60.1995L38.8243 59.2195L36.3043 59.6095C36.2643 59.2795 36.2443 58.9295 36.2343 58.5595L38.7043 58.2195L38.5543 57.2595ZM37.3343 55.5495L36.5443 56.0495C36.9943 56.4995 37.3543 56.9095 37.6143 57.2795L38.4343 56.7095C38.1743 56.3895 37.8043 55.9995 37.3343 55.5495ZM40.9743 56.0095V57.0295H43.7343V57.6095C43.7143 58.1395 43.6743 58.6395 43.6143 59.1195H40.3343V60.1295H43.4343C43.3043 60.6495 43.1443 61.1295 42.9443 61.5695C42.4643 62.5095 41.5443 63.2995 40.1643 63.9295L40.7543 64.8595C42.1343 64.2795 43.1343 63.4395 43.7543 62.3395C44.0843 61.7195 44.3343 60.9795 44.5143 60.1295H45.0543V63.4395C45.0543 64.2695 45.4443 64.6895 46.2243 64.6895H47.8143C48.2343 64.6895 48.5543 64.5895 48.7543 64.3995C48.9743 64.1995 49.1343 63.5595 49.2243 62.4795L48.2443 62.1495C48.2043 62.9095 48.1343 63.3595 48.0243 63.4995C47.9343 63.6395 47.7943 63.7195 47.6143 63.7195H46.5443C46.2443 63.7195 46.0943 63.5495 46.0943 63.2295V60.1295H49.0843V59.1195H44.6843C44.7443 58.6495 44.7743 58.1495 44.7943 57.6095V57.0295H48.2943V56.0095H40.9743ZM55.3743 55.6195V57.0995H53.1143V58.1095H55.3743V59.6595H52.6343V60.6795H54.7943C54.1143 62.2795 53.5543 63.2595 53.1343 63.6395C53.0843 63.6695 53.0143 63.6995 52.9143 63.7295L53.1443 64.6395C54.8843 64.4695 56.4943 64.2395 57.9843 63.9395C58.1043 64.2395 58.2343 64.5595 58.3643 64.8995L59.3543 64.4595C58.9143 63.3195 58.4043 62.2595 57.8243 61.2595L56.8143 61.5995C57.0743 62.0395 57.3243 62.5095 57.5743 63.0295C56.5443 63.2395 55.5043 63.4095 54.4643 63.5295C54.8843 62.9095 55.3743 61.9595 55.9143 60.6795H59.1543V59.6595H56.4343V58.1095H58.8943V57.0995H56.4343V55.6195H55.3743ZM51.1143 55.6795L50.3643 56.3995C51.0743 56.9395 51.6243 57.4395 52.0043 57.9095L52.7443 57.1595C52.2943 56.6695 51.7543 56.1795 51.1143 55.6795ZM50.8643 58.0195L50.1243 58.7395C50.7743 59.2895 51.2743 59.7995 51.6243 60.2595L52.3743 59.5195C51.9543 59.0195 51.4543 58.5195 50.8643 58.0195ZM51.7643 60.8495C51.3343 62.0295 50.8243 63.1895 50.2343 64.3095L51.2843 64.7695C51.8043 63.6695 52.2843 62.4895 52.7143 61.2395L51.7643 60.8495ZM61.6443 59.2895V63.1195H67.8243V59.2895H61.6443ZM66.8043 62.1995H62.6643V61.6595H66.8043V62.1995ZM62.6643 60.7795V60.2095H66.8043V60.7795H62.6643ZM60.5843 56.3895V57.3495H63.3343C62.5843 57.8895 61.5043 58.3395 60.0843 58.7195L60.6543 59.6395C62.2443 59.0495 63.4343 58.3095 64.2243 57.4195V58.9995H65.2443V57.4195C65.9943 58.3295 67.2043 59.0695 68.8743 59.6395L69.3243 58.6995C67.9443 58.3595 66.8943 57.9095 66.1543 57.3495H68.8843V56.3895H65.2443V55.5795H64.2243V56.3895H60.5843ZM60.3843 63.6395V64.5895H69.0543V63.6395H60.3843ZM70.8743 57.3295V58.2095H73.5243C73.4243 58.3495 73.3243 58.4995 73.2243 58.6395H70.3343V59.5595H72.4743C71.8143 60.2595 71.0143 60.9195 70.0743 61.5595L70.6343 62.4595C71.1143 62.1195 71.5743 61.7695 72.0143 61.3995V64.8695H73.0043V64.4995H77.2543V64.8695H78.2443V59.9795H73.4243C73.5343 59.8495 73.6443 59.7095 73.7643 59.5595H79.1743V58.6395H74.3843C74.4643 58.4995 74.5443 58.3495 74.6243 58.2095H78.5943V57.3295H75.0343C75.0943 57.1695 75.1543 57.0095 75.2143 56.8395C76.4843 56.7395 77.5943 56.5895 78.5543 56.3895L78.0743 55.5695C76.1243 55.9395 73.7443 56.1295 70.9343 56.1295L71.2143 56.9795C72.2743 56.9795 73.2743 56.9495 74.2043 56.9095L74.0143 57.3295H70.8743ZM73.0043 62.0195H77.2543V62.4295H73.0043V62.0195ZM77.2543 61.2395H73.0043V60.8195H77.2543V61.2395ZM73.0043 63.2095H77.2543V63.6595H73.0043V63.2095Z"
                        fill="#9D9D9D"
                      />
                      <g clip-path="url(#clip0_14306_4434)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M40.9859 32.1288C40.8477 32.4824 40.746 32.8492 40.6823 33.2235C37.6894 33.8842 35.4287 36.4913 35.4287 39.6395C35.4287 43.2967 38.4787 46.2145 42.1805 46.2145H55.0716L53.2859 44.4288H42.1805C39.4126 44.4288 37.2144 42.2592 37.2144 39.6395C37.2144 37.202 39.1144 35.152 41.6073 34.8788L42.4037 34.7895V33.9913C42.4037 33.8574 42.4144 33.7199 42.4359 33.5788L40.9859 32.1288ZM45.5394 29.5395L44.2448 28.2449C45.8622 27.158 47.7658 26.5757 49.7144 26.5717C54.518 26.5717 58.5055 30.1431 58.9394 34.7485C61.7823 35.1502 64.0001 37.5306 64.0001 40.452C63.9971 41.4224 63.747 42.3761 63.2733 43.223C62.7997 44.07 62.1182 44.7824 61.293 45.2931L59.9841 43.9842C61.318 43.3181 62.2144 41.9752 62.2144 40.452C62.2144 38.2806 60.393 36.4735 58.0841 36.4735H57.1912V35.5806C57.193 31.6163 53.8716 28.3574 49.7144 28.3574C48.1519 28.3574 46.718 28.8217 45.5376 29.5377L45.5394 29.5395ZM59.7966 48.6324L38.368 27.2038L39.6323 25.9395L61.0609 47.3681L59.7984 48.6306L59.7966 48.6324Z"
                          fill="#979797"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_14306_4434">
                          <rect x="35.4287" y="23" width="28.5714" height="28.5714" rx="8" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <svg
                      width="100"
                      height="100"
                      viewBox="0 0 100 100"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      v-else
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="99"
                        height="99"
                        rx="7.5"
                        fill="#EFEFEF"
                        stroke="#9D9D9D"
                        stroke-dasharray="2 2"
                      />
                      <path
                        d="M38.3831 65.08C36.7364 65.08 35.9131 64.1633 35.9131 62.33V60.75C35.9131 58.9167 36.7498 58 38.4231 58C39.1898 58 39.7964 58.2167 40.2431 58.65C40.6898 59.0767 40.9131 59.7767 40.9131 60.75V62.33C40.9131 63.3033 40.6831 64.0067 40.2231 64.44C39.7698 64.8667 39.1564 65.08 38.3831 65.08ZM38.4231 63.91C38.8231 63.91 39.1198 63.7833 39.3131 63.53C39.5064 63.27 39.6031 62.8633 39.6031 62.31V60.82C39.6031 60.2333 39.5064 59.81 39.3131 59.55C39.1198 59.2833 38.8231 59.15 38.4231 59.15C38.0031 59.15 37.6998 59.28 37.5131 59.54C37.3264 59.7933 37.2331 60.22 37.2331 60.82V62.31C37.2331 62.8767 37.3264 63.2867 37.5131 63.54C37.6998 63.7867 38.0031 63.91 38.4231 63.91ZM43.9227 58.94C43.7427 58.94 43.6094 58.9833 43.5227 59.07C43.4427 59.15 43.4027 59.2733 43.4027 59.44V59.8H44.3327V60.67H43.4027V65H42.1727V60.67H41.6227V59.8H42.1727V59.49C42.1727 59.05 42.296 58.71 42.5427 58.47C42.796 58.2233 43.1527 58.1 43.6127 58.1H44.3327V58.94H43.9227ZM47.2625 58.94C47.0825 58.94 46.9492 58.9833 46.8625 59.07C46.7825 59.15 46.7425 59.2733 46.7425 59.44V59.8H47.6725V60.67H46.7425V65H45.5125V60.67H44.9625V59.8H45.5125V59.49C45.5125 59.05 45.6359 58.71 45.8825 58.47C46.1359 58.2233 46.4925 58.1 46.9525 58.1H47.6725V58.94H47.2625ZM50.0625 65C49.5625 65 49.1725 64.8633 48.8925 64.59C48.6192 64.3167 48.4825 63.9267 48.4825 63.42V58.1H49.7225V63.34C49.7225 63.5533 49.7592 63.7067 49.8325 63.8C49.9125 63.8867 50.0392 63.93 50.2125 63.93H50.6325V65H50.0625ZM51.4035 59.8H52.6335V65H51.4035V59.8ZM51.3835 58.1H52.6435V59.09H51.3835V58.1ZM53.7656 59.8H54.9756V60.27C55.1289 60.0967 55.3123 59.9667 55.5256 59.88C55.7456 59.7867 55.9723 59.74 56.2056 59.74C56.7389 59.74 57.1523 59.9067 57.4456 60.24C57.7389 60.5733 57.8856 61.03 57.8856 61.61V65H56.6456V61.76C56.6456 61.4667 56.5723 61.24 56.4256 61.08C56.2789 60.92 56.0823 60.84 55.8356 60.84C55.5956 60.84 55.3956 60.92 55.2356 61.08C55.0823 61.24 55.0056 61.4667 55.0056 61.76V65H53.7656V59.8ZM60.1009 62.77V62.91C60.1009 63.2967 60.1876 63.5733 60.3609 63.74C60.5342 63.9067 60.7809 63.99 61.1009 63.99C61.3476 63.99 61.5409 63.94 61.6809 63.84C61.8209 63.7333 61.8976 63.5867 61.9109 63.4L61.9209 63.37H63.1009V63.42C63.1009 63.9133 62.9176 64.31 62.5509 64.61C62.1842 64.91 61.6842 65.06 61.0509 65.06C60.3842 65.06 59.8542 64.87 59.4609 64.49C59.0676 64.1033 58.8709 63.51 58.8709 62.71V62.08C58.8709 61.3 59.0609 60.7167 59.4409 60.33C59.8209 59.9367 60.3442 59.74 61.0109 59.74C61.6642 59.74 62.1809 59.9367 62.5609 60.33C62.9476 60.7233 63.1409 61.3067 63.1409 62.08V62.77H60.1009ZM61.0109 60.8C60.7176 60.8 60.4909 60.8833 60.3309 61.05C60.1776 61.2167 60.1009 61.4967 60.1009 61.89V61.92H61.9009V61.79C61.9009 61.13 61.6042 60.8 61.0109 60.8ZM30.9077 76.06C30.2543 76.06 29.7377 75.8833 29.3577 75.53C28.9843 75.1767 28.7977 74.6267 28.7977 73.88V72.91C28.7977 72.17 28.9843 71.6233 29.3577 71.27C29.7377 70.9167 30.2543 70.74 30.9077 70.74C31.5477 70.74 32.0477 70.9033 32.4077 71.23C32.7677 71.5567 32.9477 72.01 32.9477 72.59V72.69H31.7677V72.63C31.7677 72.3833 31.691 72.19 31.5377 72.05C31.391 71.91 31.1877 71.84 30.9277 71.84C30.3277 71.84 30.0277 72.2033 30.0277 72.93V73.87C30.0277 74.2633 30.1043 74.5433 30.2577 74.71C30.4177 74.8767 30.641 74.96 30.9277 74.96C31.1877 74.96 31.391 74.8933 31.5377 74.76C31.691 74.6267 31.7677 74.44 31.7677 74.2V74.14H32.9477V74.21C32.9477 74.7833 32.7677 75.2367 32.4077 75.57C32.0477 75.8967 31.5477 76.06 30.9077 76.06ZM35.8165 70.74C36.4765 70.74 36.9832 70.8967 37.3365 71.21C37.6898 71.5167 37.8665 71.9733 37.8665 72.58V76H36.6665V75.55C36.4932 75.73 36.3132 75.86 36.1265 75.94C35.9465 76.02 35.7165 76.06 35.4365 76.06C34.9032 76.06 34.4898 75.9167 34.1965 75.63C33.9032 75.3433 33.7565 74.9467 33.7565 74.44C33.7565 73.9733 33.9132 73.6067 34.2265 73.34C34.5398 73.0667 34.9765 72.93 35.5365 72.93H36.6365V72.52C36.6365 71.9667 36.3598 71.69 35.8065 71.69C35.5732 71.69 35.3865 71.75 35.2465 71.87C35.1132 71.9833 35.0465 72.1367 35.0465 72.33V72.36H33.8965V72.32C33.8965 71.8333 34.0698 71.45 34.4165 71.17C34.7632 70.8833 35.2298 70.74 35.8165 70.74ZM35.7165 75.06C36.0432 75.06 36.2765 74.9867 36.4165 74.84C36.5632 74.6867 36.6365 74.4567 36.6365 74.15V73.78H35.7365C35.2165 73.78 34.9565 73.99 34.9565 74.41C34.9565 74.8433 35.2098 75.06 35.7165 75.06ZM38.9463 70.8H40.1563V71.27C40.3096 71.0967 40.4929 70.9667 40.7063 70.88C40.9263 70.7867 41.1529 70.74 41.3863 70.74C41.9196 70.74 42.3329 70.9067 42.6263 71.24C42.9196 71.5733 43.0663 72.03 43.0663 72.61V76H41.8263V72.76C41.8263 72.4667 41.7529 72.24 41.6063 72.08C41.4596 71.92 41.2629 71.84 41.0163 71.84C40.7763 71.84 40.5763 71.92 40.4163 72.08C40.2629 72.24 40.1863 72.4667 40.1863 72.76V76H38.9463V70.8ZM43.8839 69.1H45.0539V71.1L43.8839 72.09V69.1ZM47.6375 71.67V74.42C47.6375 74.7733 47.8075 74.95 48.1475 74.95H48.5375V76H47.9475C47.4742 76 47.0975 75.8667 46.8175 75.6C46.5442 75.3267 46.4075 74.96 46.4075 74.5V71.67H45.6875V70.8H46.4075V69.78L47.6375 69.35V70.8H48.6375V71.67H47.6375ZM51.133 70.8H52.443L53.453 74.1L54.453 70.8H55.763L53.953 76H52.933L51.133 70.8ZM56.4474 70.8H57.6774V76H56.4474V70.8ZM56.4274 69.1H57.6874V70.09H56.4274V69.1ZM59.9495 73.77V73.91C59.9495 74.2967 60.0362 74.5733 60.2095 74.74C60.3829 74.9067 60.6295 74.99 60.9495 74.99C61.1962 74.99 61.3895 74.94 61.5295 74.84C61.6695 74.7333 61.7462 74.5867 61.7595 74.4L61.7695 74.37H62.9495V74.42C62.9495 74.9133 62.7662 75.31 62.3995 75.61C62.0329 75.91 61.5329 76.06 60.8995 76.06C60.2329 76.06 59.7029 75.87 59.3095 75.49C58.9162 75.1033 58.7195 74.51 58.7195 73.71V73.08C58.7195 72.3 58.9095 71.7167 59.2895 71.33C59.6695 70.9367 60.1929 70.74 60.8595 70.74C61.5129 70.74 62.0295 70.9367 62.4095 71.33C62.7962 71.7233 62.9895 72.3067 62.9895 73.08V73.77H59.9495ZM60.8595 71.8C60.5662 71.8 60.3395 71.8833 60.1795 72.05C60.0262 72.2167 59.9495 72.4967 59.9495 72.89V72.92H61.7495V72.79C61.7495 72.13 61.4529 71.8 60.8595 71.8ZM63.3791 70.8H64.6891L65.4991 74.1L66.4991 70.8H67.4291L68.4291 74.1L69.2391 70.8H70.5591L69.0291 76H67.9791L66.9591 72.63L65.9491 76H64.8991L63.3791 70.8Z"
                        fill="#9D9D9D"
                      />
                      <g clip-path="url(#clip0_14669_3492)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M41.5571 32.1288C41.419 32.4824 41.3173 32.8492 41.2536 33.2235C38.2607 33.8842 36 36.4913 36 39.6395C36 43.2967 39.05 46.2145 42.7518 46.2145H55.6429L53.8571 44.4288H42.7518C39.9839 44.4288 37.7857 42.2592 37.7857 39.6395C37.7857 37.202 39.6857 35.152 42.1786 34.8788L42.975 34.7895V33.9913C42.975 33.8574 42.9857 33.7199 43.0071 33.5788L41.5571 32.1288ZM46.1107 29.5395L44.8161 28.2449C46.4335 27.158 48.3371 26.5757 50.2857 26.5717C55.0893 26.5717 59.0768 30.1431 59.5107 34.7485C62.3536 35.1502 64.5714 37.5306 64.5714 40.452C64.5684 41.4224 64.3182 42.3761 63.8446 43.223C63.371 44.07 62.6895 44.7824 61.8643 45.2931L60.5554 43.9842C61.8893 43.3181 62.7857 41.9752 62.7857 40.452C62.7857 38.2806 60.9643 36.4735 58.6554 36.4735H57.7625V35.5806C57.7643 31.6163 54.4429 28.3574 50.2857 28.3574C48.7232 28.3574 47.2893 28.8217 46.1089 29.5377L46.1107 29.5395ZM60.3679 48.6324L38.9393 27.2038L40.2036 25.9395L61.6321 47.3681L60.3696 48.6306L60.3679 48.6324Z"
                          fill="#979797"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_14669_3492">
                          <rect x="36" y="23" width="28.5714" height="28.5714" rx="8" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </el-image>

                <AudioPlayerVue v-for="file in audioFileList" :key="file.id" :src="file.url" />
              </template>
            </div>
          </div>
          <svg-icon :iconClass="'sortMemo'"></svg-icon>
        </div>

        <div
          class="related"
          v-if="
            (memo.linked_memos && memo.linked_memos.length) || (memo.backlinked_memos && memo.backlinked_memos.length)
          "
          v-show="!is_Sort"
        >
          <ul>
            <li
              @click.stop="openThread(linked_memo)"
              v-for="linked_memo in memo.linked_memos"
              v-bind:key="linked_memo.slug"
            >
              <svg-icon iconClass="linkedMemo" className="icon"></svg-icon>
              <div class="text">
                {{ formatTimeStringToDate(linked_memo.created_at) }}:
                {{ summary(linked_memo.content) }}
              </div>
            </li>
            <li @click.stop="openThread(memo)" v-if="memo.backlinked_memos && memo.backlinked_memos.length">
              <svg-icon iconClass="backlinkedMemo" className="icon"></svg-icon>
              <div class="text">
                {{
                  $t('components.Memo.backlinked_count', {
                    backlinked_count: memo.backlinked_memos.length,
                  })
                }}
              </div>
            </li>
          </ul>
        </div>
        <div class="placeholder" v-if="!is_edit && !is_Thread"></div>
      </div>
    </div>
    <fl-editor
      v-if="is_edit"
      ref="fl_editor"
      :autoFocus="true"
      :initContent="editInitContent"
      :initFiles="memo.files"
      :draftKey="'draft:edit:' + memo.slug"
      :apiEndPoint="'/api/memo/' + memo.slug"
      :memo_slug="memo.slug"
      :http_direct="http_direct"
      v-on:memo-updated="memoUpdated"
      v-on:cancel-button-clicked="changeToDisplayMode"
      :onFocus="beFocus"
      :onBlur="beBlur"
      :show_all="show_all"
      :is_review="is_review"
    ></fl-editor>
  </div>
</template>
<script>
import DateUtil from '../utils/DateUtil'
import MemoUtil from '../utils/MemoUtil'
//import FlEditor from '../pages/FlEditor.vue'
import DBUtil from '../utils/DBUtil'
//import AudioPlayerVue from './AudioPlayer.vue'
import { getImgUrl, unxss } from '../utils/utils'
import logClickEvent from '../utils/logClickEvent'
import languageMixin from '../mixins/languageMixin'
import { isAiAllowHost } from '@utils/aiLimit'

export default {
  mixins: [languageMixin],
  name: 'Memo',
  props: {
    memo: {
      type: Object,
      default: {},
    },
    highlight_word: {
      type: String,
      default: null,
    },
    menu_thread_hidden: {
      type: Boolean,
      default: false,
    },
    menu_delete_hidden: {
      type: Boolean,
      default: false,
    },
    backlink_hidden: {
      type: Boolean,
      default: false,
    },
    is_recycl: {
      type: Boolean,
      default: false,
    },
    http_direct: {
      type: Boolean,
      default: false,
    },
    is_Thread: {
      type: Boolean,
      default: false,
    },
    is_Sort: {
      type: Boolean,
      default: false,
    },
    is_review: {
      type: Boolean,
      default: false,
    },
    isRecomment: {
      type: Boolean,
      default: false,
    },
    similarity: {
      type: Number,
      default: 0,
    },
    isInPinWindow: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FlEditor: () => import('../pages/FlEditor.vue'),
    AudioPlayerVue: () => import('./AudioPlayer.vue'),
  },
  data() {
    return {
      is_mobile: document.body.clientWidth <= 640,
      tools_show: false,
      is_edit: false,
      editInitContent: null,
      v_viewer_option: {
        inline: false,
        button: true,
        navbar: true,
        title: false,
        toolbar: false,
        tooltip: false,
        movable: true,
        zoomable: true,
        rotatable: false,
        scalable: false,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: 'data-source',
      },
      show_all: false,
      tooltip: {},
      me: this.$store.state.me,
      deleteTip: null,
      isClickUndo: false,
      isFocus: false,
      isElectron: this.$store.getters.isElectron,
      isShowExpand: false,
      language: 'zh',
      memoHeight: 0,
    }
  },
  computed: {
    showAiIcon() {
      const { use_llm } = this.$store.state.me
      return isAiAllowHost() && use_llm
    },
    isDark() {
      return document.body.classList.contains('dark_mode')
    },
    isOnLine() {
      return this.$store.state.isOnLine
    },
    needFold() {
      // if (this.memo.pin && !this.memo.is_pinned_list) return true
      if (this.is_Thread && !this.isRecomment) return false
      let user_settings = this.$store.state.user_settings
      for (let i = 0; i < user_settings.length; i++) {
        if (user_settings[i].type !== 1003) continue
        return parseInt(user_settings[i].value) == 1
      }
      return false
    },
    // 是否展示pin
    isShowPin() {
      // let flog = false
      // const { query, selected_tag, start_date, end_date, type } = this.$store.state
      // if (this.memo.pin) {
      //   flog = true
      //   if (query) {
      //     flog = false
      //   }
      //   if (selected_tag) {
      //     flog = false
      //   }
      //   if (start_date || end_date) {
      //     flog = false
      //   }

      //   if (type) {
      //     flog = false
      //   }
      // }

      return this.memo.pin
    },
    memoWordCount() {
      return MemoUtil.getMemoWordCount(this.memo.content)
    },
    // 判断浏览器是不是safari
    isSafari() {
      return navigator.userAgent.indexOf('Safari') > -1
    },
    isLocal() {
      return !this.memo.slug.indexOf('local')
    },
    focused() {
      return this.$store.state.focused
    },
    editMemoSlug() {
      return this.$store.state.editMemoSlug
    },
    imageFileList() {
      return this.memo.files.filter((file) => {
        return typeof file.type === 'string' && file.type.indexOf('image') > -1
      })
    },
    audioFileList() {
      return this.memo.files.filter((file) => {
        return file.type == 'audio'
      })
    },
    imgPreviewList() {
      return this.memo.files
        .filter((file) => {
          return file.type.indexOf('image') > -1
        })
        .map((file) => {
          return file.url
        })
    },
    is_pro() {
      return this.$store.getters.is_pro
    },
  },

  methods: {
    openMemo(memo) {
      window.ipcRenderer.send('open-memo-in-main', { slug: memo.slug })
    },
    showRecommend() {
      this.$emit('open-thread', this.memo.slug, false, true)
    },
    getPreviewImages(index) {
      let tempImgList = this.memo.files
        .filter((file) => {
          return file.type.indexOf('image') > -1
        })
        .map((file) => {
          return file.url
        }) //所有图片地址
      if (index == 0) return tempImgList
      // 调整图片顺序，把当前图片放在第一位
      let start = tempImgList.splice(index)
      let remain = tempImgList.splice(0, index)
      return start.concat(remain) //将当前图片调整成点击缩略图的那张图片
    },
    isShowTool(memo_content) {
      if (memo_content && memo_content.length > 460) {
        return true
      }
      return false
    },

    renderMemoContent(pre_content) {
      return MemoUtil.renderMemoContent(pre_content, this.highlight_word)
    },
    async removeMemo(memo) {
      if (this.http_direct) {
        await DBUtil.deleteMemoDirect({ slug: memo.slug })
      } else {
        await DBUtil.deleteMemo({ slug: memo.slug }, true)
      }

      this.tools_show = false
      if (this.deleteTip) {
        this.deleteTip.close()
      }
      this.deleteTip = this.$message({
        dangerouslyUseHTMLString: true,
        message: `<div class='tip-content'><div>${this.$t(
          'components.TagTree.delete_tag_messages.success',
        )}</div><div class='tip-action'><span  class='undoText'>${this.$t(
          'components.TagTree.delete_tag_messages.undo',
        )}</span> <svg  class='closeTipIcon' width='13' height='13' viewBox='0 0 13 13' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M2.74577 1.9209L1.9209 2.74577L6.17513 7L1.9209 11.2542L2.74577 12.0791L7 7.82487L11.2542 12.0791L12.0791 11.2542L7.82487 7L12.0791 2.74577L11.2542 1.9209L7 6.17513L2.74577 1.9209Z' fill='#8F9193'/</svg></div></div>`,
        duration: 3000,
        offset: window.innerHeight - 100,
        customClass: 'delete-tip',
        onClose: () => {
          if (!this.isClickUndo) {
            DBUtil.clearDeleteMemoSlugs()
          }
        },
      })
      // 撤销删除
      this.deleteTip.$el.querySelector('span').onclick = async () => {
        this.isClickUndo = true
        this.deleteTip.close()
        const msgTip = this.$message({
          dangerouslyUseHTMLString: true,
          message: `<div class='tip-content'><div>${this.$t(
            'components.TagTree.delete_tag_messages.undoing',
          )}</svg></div></div>`,
          duration: 0,
          offset: window.innerHeight - 100,
          customClass: 'undo-tip',
        })
        await DBUtil.undoDeleteMemo()
        setTimeout(() => {
          msgTip.close()
        }, 500)
      }
      // 关闭提示
      this.deleteTip.$el.querySelector('svg').onclick = () => {
        DBUtil.clearDeleteMemoSlugs()
        this.deleteTip.close()
        this.isClickUndo = false
      }
      // this.$message.success(this.$t("components.Memo.messages.delete_success"));
      this.$emit('memo-removed', memo)
    },
    getDraft() {
      let draft_key = 'draft:edit:' + this.memo.slug
      return localStorage.getItem(draft_key)
    },
    changeToEditMode() {
      if (this.is_recycl || this.is_edit) {
        return
      }

      let draft = this.getDraft()
      this.$emit('memo-editing', true)
      if (!draft) {
        this.editInitContent = this.memo.content
        this.is_edit = true
        this.tools_show = false
      } else {
        this.$confirm('你有之前尚未保存的草稿，是否恢复？', '提示', {
          confirmButtonText: '恢复编辑',
          cancelButtonText: '丢弃草稿',
          type: 'warning',
          customClass: 'confirm',
        })
          .then(() => {
            this.editInitContent = draft
            this.is_edit = true
            this.tools_show = false
          })
          .catch(() => {
            this.editInitContent = this.memo.content
            this.is_edit = true
            this.tools_show = false
          })
      }
    },
    changeToDisplayMode() {
      this.is_edit = false
      this.$emit('memo-editing', false)
      if (!this.is_review && !this.is_Thread) {
        setTimeout(() => {
          this.scrollIntoView(this.$refs.memo_container, { behavior: 'smooth', block: 'center', inline: 'center' })
        }, 500)
      }
    },
    copyLink(_memo) {
      let vm = this

      if (_memo.slug.indexOf('local_') >= 0) {
        vm.$message.error(vm.$t('components.Memo.messages.offline_memo_reject'))
        return
      }

      vm.$copyText(MemoUtil.getMemoUrl(_memo.slug)).then(
        function (e) {
          vm.$message.success(vm.$t('components.Memo.messages.copy_link_success'))
        },
        function (e) {
          vm.$message.error(vm.$t('components.Memo.messages.copy_link_failed'))
        },
      )
    },
    addLinkedMemo(_memo) {
      if (_memo.slug.indexOf('local_') >= 0) {
        this.$message.error(this.$t('components.Memo.messages.offline_memo_reject'))
        return
      }
      this.$emit('add-linked-memo', _memo)
    },
    memoUpdated(_memo) {
      //this.$emit('memo-updated', _memo)
      this.memo = {
        ..._memo,
        tipLoading: true,
      }

      setTimeout(() => {
        this.memo = {
          ...this.memo,
          tipLoading: false,
        }
      }, 5000)
      this.$emit('memo-editing', false)
      this.is_edit = false
      this.checkHeight()
    },
    memoClicked(_memo, event) {
      if (event.target.localName == 'button') return
      if (event.target.localName == 'svg') return
      if (event.target.localName == 'path') return
      if (event.target.localName == 'img') return

      if (this.is_recycl) {
        return
      }

      if (event.target.className == 'tag') {
        let tag = event.target.innerHTML.replace('#', '')
        tag = tag.replace(/<[^>]+>/g, '')
        if (this.isInPinWindow) {
          window.ipcRenderer.send('tag-clicked', tag)
          return
        }
        this.$emit('tag-clicked', tag)
        logClickEvent('MEMO卡片', '点击标签')
        return
      }
      if (event.target.className == 'highlight' && event.target.parentNode.className == 'tag') {
        let tag = event.target.parentNode.innerHTML.replace('#', '')
        tag = tag.replace(/<label.*?>|<\/label>/gi, '') // 去掉高亮 HTML
        this.$emit('tag-clicked', tag)
        logClickEvent('MEMO卡片', '点击标签')
        return
      }
      if (event.target.localName == 'a') {
        event.stopPropagation()
        event.preventDefault()
        if (event.target.className == 'inner_memo_link') {
          let memoSlug = event.target.attributes.slug.nodeValue
          //this.$emit('open-thread', memoSlug)
          if (this.isInPinWindow) {
            window.ipcRenderer.send('open-memo-in-main', { slug: memoSlug })
          } else {
            this.$emit('open-thread', memoSlug)
          }
          return
        }
        if (event.target.className == 'blank_memo_link' && this.isElectron) {
          window.ipcRenderer.send('openUrl', event.target.getAttribute('href'))
        } else {
          window.open(event.target.getAttribute('href'))
        }
      }

      // this.$emit('open-thread', _memo);
    },
    openThread(_memo) {
      if (this.isInPinWindow) {
        window.ipcRenderer.send('open-memo-in-main', { slug: _memo.slug })
      } else {
        this.$emit('open-thread', _memo.slug)
        this.tools_show = false
      }
    },
    summary(content) {
      if (!content) return content
      content = unxss(content)
      return content.replace(/<\/?[^<>]*>/g, '').trim()
    },
    shareClicked(_memo) {
      this.$emit('share-clicked', _memo)
    },
    formatTimeStringToDate(datestring) {
      return DateUtil.formatDateStringToDateOnly(datestring)
    },
    showAll() {
      this.show_all = true
    },
    showSummary() {
      this.show_all = false
      setTimeout(() => {
        this.scrollIntoView(this.$refs.memo_container, { behavior: 'smooth', block: 'center', inline: 'center' })
      }, 500)
    },
    scrollIntoView(el, options) {
      if (el.scrollIntoViewIfNeeded) {
        el.scrollIntoViewIfNeeded(options)
      } else {
        el.scrollIntoView(options)
      }
    },
    deleteMemo(memo) {
      let vm = this
      DBUtil.deleteMemo(memo)
      vm.$message.success(vm.$t('components.Memo.messages.delete_success'))
      vm.$emit('memo-removed', memo)
      // this.$http
      // 	.post("/api/memo/" + memo.slug + "/delete")
      // 	.then((response) => {
      // 		if (response.data && response.data.code === -1) {
      // 			vm.$message.error(response.data.message);
      // 		} else if (response.data && response.data.code === 0) {
      // 			vm.$message.success(response.data.message);
      // 			vm.$emit("memo-removed", memo);
      // 		}
      // 	});
    },
    restoreMemo(memo) {
      let vm = this
      DBUtil.restoreMemo(memo)
      vm.$message.success(vm.$t('components.Memo.messages.restore_success'))
      vm.$emit('memo-removed', memo)
      // this.$http
      // 	.post("/api/memo/" + memo.slug + "/restore")
      // 	.then((response) => {
      // 		if (response.data && response.data.code === -1) {
      // 			vm.$message.error(response.data.message);
      // 		} else if (response.data && response.data.code === 0) {
      // 			vm.$message.success(response.data.message);
      // 			vm.$emit("memo-removed", memo);
      // 		}
      // 	});
    },
    pinMemoToDesk(memo) {
      window.ipcRenderer.send('pin-memo-to-desk', { slug: memo.slug, height: this.memoHeight })
    },

    async pinMemo(memo) {
      let vm = this

      if (memo.slug.indexOf('local_') >= 0) {
        vm.$message.error(vm.$t('components.Memo.messages.offline_memo_reject'))
        return
      }
      let result = null
      if (this.http_direct) {
        result = await DBUtil.pinMemoDirect(memo)
      } else {
        result = await DBUtil.updateMemoPinByMemo(memo)
      }
      if (result) {
        vm.memo.pin = 1
        vm.$emit('memo-pinned', memo)
        vm.$message.success(vm.$t('components.Memo.messages.pin_success'))
      } else {
        vm.$message.error(vm.$t('components.Memo.messages.pin_failed'))
      }
      // this.$http
      //     .post("/api/memo/" + memo.slug + "/pin")
      //     .then(response => {
      //         if (response.data && response.data.code === -1) {
      //             vm.$message.error(response.data.message);
      //         } else if (
      //             response.data &&
      //             response.data.code === 0
      //         ) {
      //             vm.$message.success(response.data.message);
      //             vm.$emit("memo-pinned", memo);
      //         }
      //     });
    },
    async unpinMemo(memo) {
      let vm = this
      let result = null
      if (this.http_direct) {
        result = await DBUtil.editMemoDirect(memo.slug, memo.content, memo.source, memo.file_ids, 0)
      } else {
        result = await DBUtil.unPinMemo(memo)
      }
      vm.memo.pin = 0
      vm.$emit('memo-unpinned', result)

      vm.$message.success(vm.$t('components.Memo.messages.unpin_success'))

      // this.$http
      //     .post("/api/memo/" + memo.slug + "/unpin")
      //     .then(response => {
      //         if (response.data && response.data.code === -1) {
      //             vm.$message.error(response.data.message);
      //         } else if (
      //             response.data &&
      //             response.data.code === 0
      //         ) {
      //             vm.$message.success(response.data.message);
      //             vm.$emit("memo-unpinned", memo);
      //         }
      //     });
    },
    copyMemo(memo) {
      let vm = this
      const copy_content = document.querySelector('.memo_' + memo.slug + '_content').innerText

      vm.$copyText(copy_content).then(
        function (e) {
          vm.$message.success(vm.$t('components.Memo.messages.copy_memo_success'))
        },
        function (e) {
          vm.$message.error(vm.$t('components.Memo.messages.copy_memo_failed'))
        },
      )
    },
    blobToUrl(blob) {
      return window.URL.createObjectURL(blob)
    },
    beFocus() {
      this.isFocus = true
    },
    beBlur() {
      this.isFocus = false
    },
    getImgPreviewUrl(file) {
      return getImgUrl(file)
    },
    // 检查高度是否超过160
    checkHeight() {
      this.$nextTick(() => {
        let richText = this.$refs.richText
        if (richText) {
          let height = richText.offsetHeight
          this.memoHeight = height
          if (height > 160) {
            this.isShowExpand = true
          } else {
            this.isShowExpand = false
          }
        }
      })
    },
  },
  mounted() {
    this.language = this.getLanguage()
    this.checkHeight()
  },
}
</script>
<style>
.tools-popover {
  min-width: auto !important;
  padding: 0px !important;
}

.tools-popover button {
  padding-left: 0px !important;
}
</style>
<style src="../../assets/css/memo.css" scoped></style>
<style src="../../assets/css/animate.css"></style>
<style scoped lang="scss">
.display {
  //content-visibility: auto;
  .header {
    .similarity {
      margin: 0 10px;
      font-size: 12px;
      color: #8f9193;
      margin-top: -2px;
    }
  }

  .memoAction {
    color: #7d7d7d;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  @keyframes opac {
    from {
      opacity: 1;
      width: 0;
      height: 0;
      top: 50%;
      left: 50%;
    }

    to {
      opacity: 0;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }
  .animate-wave {
    width: 5px;
    height: 5px;
    display: inline-block;
    margin: 2px 5px;
    background: #c3e4ff;
    border-radius: 50%;
    position: relative;
    left: 0;
    right: 0;
  }

  .animate-wave * {
    background: linear-gradient(0deg, #5f74f1, #5f74f1),
      linear-gradient(0deg, rgba(95, 116, 241, 0.1), rgba(95, 116, 241, 0.1));
    border-radius: 50%;
    animation: opac 4s infinite;
    position: absolute;
  }

  .animate-wave .w2 {
    animation-delay: 1s;
  }

  .animate-wave .w3 {
    animation-delay: 2s;
  }

  .animate-wave .w4 {
    animation-delay: 3s;
  }
}
.showRecommend {
  .header {
    .time {
      .recommend {
        display: none;
        width: auto;
      }
    }
  }

  &:hover {
    .header {
      .time {
        .recommend {
          display: block;
        }
        .text {
          display: none;
        }
      }
    }
  }
}
</style>
